module.exports = __webpack_public_path__ + "static/img/4.5143e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital0/4.png
// module id = 2hBR
// module chunks = 1